module.exports = __webpack_public_path__ + "media/images/products/template/01/02-cfa77864090b8ec35f3fba5b1f51d8c3.jpg";